module.exports = __webpack_public_path__ + "img/313dd81b844e8542a4cd0999f8a1d45a.png";